import { Button, Callout, Text } from "@/components/ui"
import { CurrencyIcon } from "@/icons"
import { formatBRL } from "@/lib/format-brl"
import type { OrderPixCharge } from "@/types/external"

type Props = {
  charge: OrderPixCharge
  onShowQr: () => void
}

/**
 * "Balance due" card for an open ad-hoc Pix charge (PIX-CHARGE D6/D7).
 * Shown between the order-status card and the item list on the order
 * detail screen. Deliberately does NOT itemize the diff — the frontend
 * has no knowledge of what caused it (D7) — and never opens the QR
 * overlay on its own; only the button does (D6).
 */
export function PixChargeDueCard({ charge, onShowQr }: Props) {
  const amount = formatBRL(charge.amountMinor / 100)

  return (
    <section aria-label="Pagamento pendente">
      <Callout
        tone="warning"
        role="none"
        titleAs="h2"
        icon={CurrencyIcon}
        title="Houve uma alteração no seu pedido"
        action={
          <Button
            fullWidth
            onClick={onShowQr}
            aria-label={`Exibir QR Code Pix para pagar a diferença de ${amount}`}
          >
            Exibir QR Code / Pix copia e cola
          </Button>
        }
      >
        É necessário pagar a diferença de <Text as="strong" weight="semibold" tone="default">{amount}</Text>.
      </Callout>
    </section>
  )
}
